<div class="iframe">
    <finder-component-header [data]="headerData"></finder-component-header>
    <iframe *ngIf="iframeData"
        [src]="iframeData.source | trustResourceUrl"
        [attr.allow]="iframeData.allow"
        [width]="iframeData.width"
        [height]="iframeData.height">
    </iframe>
</div>
